import React from 'react';

import { useActions, useTypedSelector } from '../../hooks';

import { Candidates } from '@vyce/core/src/views/hiring/Candidates';

export const EmployerCandidates: React.FC = () => {
  const { first_name, last_name, phone, email } = useTypedSelector(state => state.user);
  const { access_token, selectedCompany, selectedPosition } = useTypedSelector(state => state.helper);
  const { setIsJobPostedStatus } = useActions();

  return (
    <>
      {selectedCompany?.uuid && (
        <Candidates
          selectedPosition={selectedPosition}
          companyId={selectedCompany.uuid}
          token={access_token}
          setIsJobPostedStatus={setIsJobPostedStatus}
          email={email}
          lastName={last_name}
          firstName={first_name}
          phone={phone}
        />
      )}
    </>
  );
};
